module.exports = {
  get: function (attributeChain) {
    if (attributeChain === 'id') return parseInt(INKIVE.Tool._current_design_id);
    if (attributeChain === 'current') return parseInt(INKIVE.Tool._current_page_number);
    if (attributeChain === 'total') return parseInt(INKIVE.C.BOOK.num_pages);

    return {
      'id': parseInt(INKIVE.Tool._current_design_id),
      'has_changes': this._hasChanges(),
      'current': parseInt(INKIVE.Tool._current_page_number),
      'total': parseInt(INKIVE.C.BOOK.num_pages)
    };
  },

  _hasChanges: function () {
    var tool = INKIVE.Tool.getInstance();
    var hasRestrictionChanges = INKIVE.RestrictionsFactory
      && !INKIVE.RestrictionsFactory.isAllSaved();

    if (hasRestrictionChanges) {
      return true;
    }

    return !INKIVE.Helpers.areEqual(
      tool.editor.getSvgString(),
      INKIVE.EditorFacade.handle('cache', 'get')
    );
  }
};
